import script from "./OrderCancelled.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderCancelled.vue?vue&type=script&setup=true&lang=ts"

import "./OrderCancelled.vue?vue&type=style&index=0&id=491cd0e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-491cd0e4"]])

export default __exports__